import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { DeliveryRepositoryToken } from '../../di/tokens';
import type { SalesDeliveryStatus } from '../../domain/entities/delivery.entity';

/**
 * Lista paginada de entregas (página de Entregas), ordenada por updatedAt desc.
 * `status` opcional filtra por status da entrega.
 */
export function useSalesDeliveries(
  page = 1,
  perPage = 10,
  status?: SalesDeliveryStatus,
) {
  const repository = container.resolve(DeliveryRepositoryToken);
  return useQuery({
    queryKey: ['delivery', 'sales-deliveries', page, perPage, status ?? 'all'],
    queryFn: () => repository.listSalesDeliveries({ page, perPage, status }),
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  });
}
